// @flow

import { createSelector } from 'reselect';
import type { OutputSelector } from 'reselect';

import { selectDomainFromFqdn } from '@gandi/cart';

import type { FullState } from '../../types';
import type {
  SearchState,
  ResultsState,
  Value as SearchValue,
  ExtendedResult,
  Result,
} from '../types';

export const selectResults = (state: FullState): ResultsState =>
  state.domainRenew.results || {};

export const selectSearch = (state: FullState): SearchState =>
  state.domainRenew.search;
export const selectSearchValue = (state: FullState): SearchValue =>
  selectSearch(state).value;
export const selectSearchLoading = (state: FullState): boolean =>
  selectSearch(state).loading;

export const selectExtendedResults: OutputSelector<
  FullState,
  void,
  Array<ExtendedResult>,
> = createSelector([selectResults, state => state], (results, state) => {
  return Object.keys(results).map(fqdn => ({
    ...results[fqdn],
    // TODO:: find another way to work than using a selector into the map
    addedToCart: !!selectDomainFromFqdn(state, fqdn),
  }));
});

export const selectRenewableResultsToAdd = (
  state: FullState,
): Array<Result> => {
  const results: ResultsState = selectResults(state);

  return Object.values(results).filter(
    (result: Result) =>
      (result.restorable || result.renewable) &&
      !selectDomainFromFqdn(state, result.fqdn),
  );
};
